const getPropsTagChipStatus = (status) => {
  let label = '';
  let kind = '';

  switch (status) {
    case 'review':
      label = 'Aguardando Aprovação';
      kind = 'attention';
      break;
    case 'paid':
      label = 'Pagamento Efetuado';
      kind = 'success';
      break;
    case 'canceled':
      label = 'Cancelado';
      kind = 'warning';
      break;
    case 'scheduled':
      label = 'Agendado';
      kind = 'scheduled';
      break;
    default:
      label = 'Aguardando Pagamento';
      kind = 'scheduled';
  }

  return { label, kind };
};

export default getPropsTagChipStatus;
